<template>
  <div class="feed">
    <button
      v-for="(item, i) in items" :key="i"
      type="button" class="insight"
      @click="$emit('pick', item)"
    >
      <span>💡</span>
      <span><b>{{ item.word }}</b> {{ item.text }}</span>
    </button>
    <!-- Расчёт всегда возвращает хотя бы одну карточку, если в срезе есть
         слова, поэтому пустая лента означает ровно одно: срез пуст. -->
    <div v-if="!items.length" class="dempty">
      Ни одно слово не проходит порог «мин. сессий со словом».
    </div>
  </div>
</template>

<script>
export default {
  name: 'InsightsFeed',
  props: {
    items: { type: Array, required: true },
  },
  emits: ['pick'],
};
</script>

<style scoped>
.feed {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 14px;
  max-height: 200px;
  overflow-y: auto;
  padding-right: 4px;
}
</style>
